'use client'

import { useEffect, useState } from 'react'

/** `null` on the server and the first client render, then `Date.now()`. */
export function useHydratedNow(): number | null {
  const [nowMs, setNowMs] = useState<number | null>(null)

  useEffect(() => {
    setNowMs(Date.now())
  }, [])

  return nowMs
}
